import axios from "axios";

const axiosInstance = axios.create({
//本地
//      baseURL: 'http://172.19.1.10:5000'
//服务器
   baseURL: "/api",
   timeout: 10000
});

export default axiosInstance;